import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesNominas() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Recursos Humanos", items: [
      { label: "Empleados", icon: "fas fa-address-card", color: "#3b82f6", href: "/Empleados", desc: "Catalogo de empleados", enabled: !!user.menu_empleados },
      { label: "Puestos", icon: "fas fa-address-book", color: "#10b981", href: "/Puestos", desc: "Catalogo de puestos", enabled: !!user.menu_puestos },
    ]},
  ];
  return (
    <MenuBotones titulo="Nominas" descripcion="Empleados y puestos" icono="fas fa-address-card" color="#3b82f6" secciones={SECCIONES} />
  );
}

export default BotonesNominas;
